import { Button, Steps, Divider, Input, Checkbox, Form, Tooltip } from 'antd'
import { HelpText } from 'Components'
import { useCreateMacroData } from './CreateMacroDataProvider'
import { QuestionCircleOutlined } from '@ant-design/icons'
import {
  setGraph
  setName
  setIsHidden
  setTypeNode
  setLabel
  setConfirmationMessage
} from './CreateMacroDataProvider/actions'

GeneralConfig = ->

  [{
    name,
    isHidden,
    typeNode,
    graph,
    label,
    confirmationMessage
   }, dispatch] = useCreateMacroData()

  <Form
    initialValues={{ name, isHidden, typeNode, graph, confirmationMessage }}
    layout="vertical"
  >
    <Form.Item
      label="Title"
      name="name"
      rules={[{ required: true, message: 'Title is required' }]}
    >
      <Input
        onChange={({ target: { value }}) -> dispatch(setName(value))}
        data-testid="configure-macro-title-field"
      />
    </Form.Item>
    <Form.Item
      label={
        <>
          Type
          <HelpText text="The type of entity this form will create. Only the subject of this form will receive this type, secondary nodes can be typed as required." />
        </>
      }
      name="typeNode"
      onChange={({ target: { value }}) ->
        value = null if _.isEmpty(value)
        dispatch(setTypeNode(value))
      }
    >
      <Input data-testid="configure-macro-type-field" />
    </Form.Item>
    <Form.Item
      label="Graph"
      name="graph"
    >
      <Input onChange={({ target: { value }}) -> dispatch(setGraph(value))} />
    </Form.Item>
    <Form.Item
      label="Confirmation message"
      name="confirmationMessage"
    >
      <Input.TextArea onChange={({ target: { value }}) -> dispatch(setConfirmationMessage(value))} />
    </Form.Item>
    <Form.Item
      label={
        <>
          Hidden
          <HelpText text="Whether or not this form will be visible from the main tree. This is useful for sub-forms of a larger workflow that won't usually be used independently of the main form." />
        </>
      }
      name="isHidden"
      valuePropName="checked"
      onChange={({ target: { checked }}) -> dispatch(setIsHidden(checked))}
    >
      <Checkbox />
    </Form.Item>
  </Form>

export default GeneralConfig
